import { useEffect, useRef } from 'react'

import { useOptionalTableContext } from '@/components/NewTable/TableContext'

/**
 * Selects the given row in the surrounding TableProvider when a popup editor
 * transitions from closed to open, so the highlighted row and properties panel
 * follow the row being edited. No-ops when used outside a TableProvider.
 */
export const useSelectRowOnOpen = <TData extends object>(
	isOpen: boolean,
	rowOriginal: TData | undefined,
) => {
	const context = useOptionalTableContext<TData>()
	const wasOpenRef = useRef(false)

	useEffect(() => {
		if (isOpen && !wasOpenRef.current && rowOriginal) {
			context?.setSelectedRow(rowOriginal)
		}
		wasOpenRef.current = isOpen
	}, [isOpen, rowOriginal, context])
}
